import type { MediaProgress } from 'room/common/media-progress'
import type { MediaStatus } from 'room/common/model/media-status'

/**
 * What the console's card for a recording says about the player on the
 * projector: what that player reported, and nothing it did not. With no
 * report - the presentation window has just opened, or its player is not
 * there yet - the file has not arrived, so the card says loading, never
 * ready. A film's report is not this recording's.
 */
export const reportedAudioStatus = (media: MediaProgress | null): MediaStatus =>
	media?.kind === 'audio' ? media.status : 'loading'
